import styled from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

const getModalCardWidth = (deviceType: DeviceType): string => {
  if (deviceType === "mobile") return "328px";
  return "450px";
};

export const StandaloneFetalSexShareModalCard = styled.div<{
  deviceType: DeviceType;
}>`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  box-sizing: border-box;
  display: grid;
  gap: 12px;
  max-height: 90vh;
  max-width: calc(100vw - 20px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ deviceType }) =>
    deviceType === "mobile" ? "24px" : "24px 32px"};
  width: ${({ deviceType }) => getModalCardWidth(deviceType)};
`;

export const StandaloneFetalSexShareModalHeader = styled.div`
  display: grid;
  gap: 4px;
`;

export const StandaloneFetalSexShareRecipientGroup = styled.div`
  display: grid;
  gap: 8px;
`;

export const StandaloneFetalSexShareRecipientHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const StandaloneFetalSexShareRemoveButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 15px;
  color: ${({ theme }) => theme.redMedium};
  cursor: pointer;
  display: inline-flex;
  font-size: 15px;
  height: 30px;
  justify-content: center;
  padding: 0;
  width: 30px;

  :hover {
    background-color: ${({ theme }) => theme.redPastel};
  }
`;

export const StandaloneFetalSexShareRecipientFields = styled.div`
  display: grid;
  gap: 24px;
  padding-top: 8px;
`;

export const StandaloneFetalSexShareAddRecipientRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StandaloneFetalSexShareTextButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 15px;
  color: ${({ theme }) => theme.redMedium};
  cursor: pointer;
  display: inline-flex;
  font-family: bold;
  font-size: 21px;
  font-weight: 700;
  gap: 0.5rem;
  height: 30px;
  justify-content: center;
  letter-spacing: 0.42px;
  line-height: 20px;
  padding: 0 8px;
  text-transform: uppercase;

  svg {
    font-size: 15px;
  }

  :hover {
    background-color: ${({ theme }) => theme.redPastel};
  }

  :disabled {
    cursor: default;
    opacity: 0.4;

    :hover {
      background-color: transparent;
    }
  }
`;

export const StandaloneFetalSexShareSubmitButton = styled(
  StandaloneFetalSexShareTextButton,
)`
  min-width: 4.5rem;
`;

export const StandaloneFetalSexShareAuthorizationRow = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
`;

export const StandaloneFetalSexShareAuthorizationText = styled.div`
  a {
    text-decoration: none;
  }

  label {
    cursor: pointer;
  }

  p {
    display: inline;
  }
`;

export const StandaloneFetalSexShareError = styled.div`
  color: ${({ theme }) => theme.redDark};
`;

export const StandaloneFetalSexShareActionRow = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding-top: 12px;
`;

export const StandaloneFetalSexShareSuccessIcon = styled.div`
  color: ${({ theme }) => theme.greenSuccess};
  display: flex;
  font-size: 36px;
  justify-content: center;
  padding-top: 8px;
`;

export const StandaloneFetalSexShareSuccessMessage = styled.div`
  display: grid;
  gap: 8px;
  justify-self: center;
  max-width: 275px;
  width: 100%;
`;

export const StandaloneFetalSexShareSuccessActionRow = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding-top: 24px;
`;
